import $ from 'jquery';

const scrollContainer = $('.scroll-behavior-smooth');
const smoothScrolling = $('html');

if (scrollContainer.is(':visible')) {
	smoothScrolling.addClass('scroll-behavior-smooth');
}